module.exports = __webpack_public_path__ + "img/youtube.9bb6172a.svg";